<template>
  <div class="terms-page">
    <navbar
      is-blur="blur blur-rounded my-3 py-2 start-0 end-0 mx-4 shadow"
      btn-background="bg-gradient-success"
      :dark-mode="true"
    />
    
    <!-- Hero Section avec design similaire -->
    <section class="terms-hero" style="padding-top: 140px; padding-bottom: 80px; background: #FFFFFF;">
      <div class="container">
        <div class="row align-items-center">
          <!-- Contenu gauche -->
          <div class="col-lg-6">
            <h1 class="terms-title mb-4">
              Conditions générales d'utilisation
              <svg class="title-underline" viewBox="0 0 350 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M2 4C70 2 280 2 348 6" stroke="#F5A847" stroke-width="3" stroke-linecap="round"/>
              </svg>
            </h1>
            
            <p class="terms-text mb-4" style="color: #8B8B8B; font-size: 0.95rem; line-height: 1.7;">
              En accédant et en utilisant les services de Nolido Cash, vous acceptez d'être lié par les présentes conditions générales d'utilisation. Ces conditions régissent tous les aspects de votre utilisation de nos services.
            </p>
            
            <h5 class="mt-5 mb-3" style="color: #2F2113; font-weight: 700;">1. Acceptation des conditions</h5>
            <p class="terms-text mb-4">
              En accédant et en utilisant les services de Nolido, vous acceptez d'être lié par les présentes conditions générales d'utilisation. Si vous n'acceptez pas ces conditions, veuillez ne pas utiliser nos services.
            </p>
            
            <h5 class="mt-5 mb-3" style="color: #2F2113; font-weight: 700;">2. Description des services</h5>
            <p class="terms-text mb-4">
              Nolido propose des solutions de distribution de monnaie électronique, incluant transferts nationaux, régionaux et internationaux.  Nos services sont fournis "tels quels" et peuvent être modifiés ou mis à jour périodiquement.
            </p>
            
            <h5 class="mt-5 mb-3" style="color: #2F2113; font-weight: 700;">3. Utilisation des services</h5>
            <p class="terms-text mb-4">
              Vous vous engagez à utiliser nos services conformément aux lois en vigueur et à ces conditions. Vous êtes responsable de maintenir la confidentialité de vos identifiants de compte et de toutes les activités qui s'y déroulent.
            </p>
            
            <h5 class="mt-5 mb-3" style="color: #2F2113; font-weight: 700;">4. Propriété intellectuelle</h5>
            <p class="terms-text mb-4">
              Tous les droits de propriété intellectuelle liés à nos services sont la propriété de Nolido Cash. Aucun contenu ne peut être copié, modifié ou distribué sans notre autorisation écrite préalable.
            </p>
            
            <div class="d-flex align-items-center mt-5" style="color: #8B8B8B; font-size: 0.85rem;">
              <i class="bi bi-clock-history me-2"></i>
              <span><strong>Dernière mise à jour :</strong> 30 Juillet 2023</span>
            </div>
          </div>
          
          <!-- Image iPhone droite -->
          <div class="col-lg-6 text-center">
            <div class="phone-mockup-container">
              <img :src="require('@/assets/img/iphone.png')" alt="Nolido App" class="phone-mockup-terms">
            </div>
          </div>
        </div>
      </div>
    </section>
    
    <!-- Composants requis -->
    <testimonials-section />
    <faq-section />
    <cta-section />
    <app-footer />
  </div>
</template>

<script>
import Navbar from "@/examples/PageLayout/Navbar.vue";
import AppFooter from "@/examples/PageLayout/Footer.vue";
import TestimonialsSection from '@/components/TestimonialsSection.vue';
import FaqSection from '@/components/FaqSection.vue';
import CtaSection from '@/components/CtaSection.vue';

export default {
  name: 'TermsPage',
  components: {
    Navbar,
    AppFooter,
    TestimonialsSection,
    FaqSection,
    CtaSection
  }
}
</script>

<style scoped>
.terms-page {
  background: #FFFFFF;
}

.terms-hero {
  min-height: 80vh;
  display: flex;
  align-items: center;
}

.terms-title {
  font-size: 3rem;
  font-weight: 800;
  color: #2F2113;
  line-height: 1.2;
  position: relative;
  display: inline-block;
  margin-bottom: 2rem;
}

.title-underline {
  position: absolute;
  bottom: -8px;
  left: 0;
  width: 100%;
  max-width: 350px;
  height: auto;
}

.terms-text {
  font-size: 0.95rem;
  color: #8B8B8B;
  line-height: 1.7;
}

.phone-mockup-container {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
}

.phone-mockup-terms {
  max-width: 400px;
  width: 100%;
  height: auto;
  filter: drop-shadow(0 20px 60px rgba(0,0,0,0.2));
}

@media (max-width: 992px) {
  .terms-title {
    font-size: 2.5rem;
  }
  
  .terms-hero {
    padding-top: 100px;
    padding-bottom: 60px;
  }
  
  .phone-mockup-terms {
    max-width: 300px;
    margin-top: 3rem;
  }
}

@media (max-width: 768px) {
  .terms-title {
    font-size: 2rem;
  }
  
  .terms-text {
    font-size: 0.9rem;
  }
  
  .phone-mockup-terms {
    max-width: 250px;
  }
}
</style>